import { DifficultyId, INTERNAL_HEIGHT, INTERNAL_WIDTH } from '../constants';
import type { InventoryState } from '../data/purchases';
import { CoreBeamId, DeviceId, NodeLensId } from '../weapons/definitions';

export class PlayerState implements InventoryState {
  x = 72;
  y = INTERNAL_HEIGHT * 0.5;
  vx = 0;
  vy = 0;
  radius = 5;
  maxLives = 3;
  lives = 3;
  invulnerabilityTicks = 0;
  respawnTicks = 0;
  fireCooldown = 0;
  deviceCooldown = 0;
  deviceActiveTicks = 0;
  score = 0;
  lux = 0;
  chain = 0;
  chainTimer = 0;
  scoreBoostTicks = 0;
  nodeRechargeLevel = 0;
  core = CoreBeamId.Pulse;
  lens = NodeLensId.Focus;
  device = DeviceId.RepairField;
  aimDirection = 0;
  aimLocked = false;
  alive = true;
  weaponLevel = 0;
  powerCharge = 0;
  weaponRhythmStep = 0;
  readonly purchaseCounts = new Uint8Array(16);

  resetForNewGame(difficulty: DifficultyId): void {
    this.x = 72;
    this.y = INTERNAL_HEIGHT * 0.5;
    this.vx = 0;
    this.vy = 0;
    this.maxLives = difficulty === DifficultyId.Calm ? 4 : 3;
    this.lives = this.maxLives;
    this.invulnerabilityTicks = 90;
    this.respawnTicks = 0;
    this.fireCooldown = 0;
    this.deviceCooldown = 0;
    this.deviceActiveTicks = 0;
    this.score = 0;
    this.lux = 0;
    this.chain = 0;
    this.chainTimer = 0;
    this.scoreBoostTicks = 0;
    this.nodeRechargeLevel = 0;
    this.core = CoreBeamId.Pulse;
    this.lens = NodeLensId.Focus;
    this.device = DeviceId.RepairField;
    this.aimDirection = 0;
    this.aimLocked = false;
    this.alive = true;
    this.weaponLevel = 0;
    this.powerCharge = 0;
    this.weaponRhythmStep = 0;
    this.purchaseCounts.fill(0);
    this.purchaseCounts[0] = 1;
    this.purchaseCounts[4] = 1;
    this.purchaseCounts[8] = 1;
  }

  resetForStage(): void {
    this.x = 72;
    this.y = INTERNAL_HEIGHT * 0.5;
    this.vx = 0;
    this.vy = 0;
    this.invulnerabilityTicks = 120;
    this.respawnTicks = 0;
    this.fireCooldown = 0;
    this.weaponRhythmStep = 0;
    this.chain = 0;
    this.chainTimer = 0;
    this.alive = true;
  }

  continueRun(lives: number): void {
    this.lives = lives;
    this.lux = Math.floor(this.lux * 0.5);
    this.resetForStage();
  }

  clampToWorld(): void {
    if (this.x < 12) this.x = 12;
    else if (this.x > INTERNAL_WIDTH - 16) this.x = INTERNAL_WIDTH - 16;
    if (this.y < 12) this.y = 12;
    else if (this.y > INTERNAL_HEIGHT - 12) this.y = INTERNAL_HEIGHT - 12;
  }
}
